<template>
    <section id="portfolio" class="section bg-light">
        <div class="container">
            <!-- Heading -->
            <p class="text-center mb-2" data-aos="fade-up" data-aos-once="true">
                <span class="bg-primary text-dark px-2">Services</span>
            </p>
            <h2 class="text-10 fw-600 text-center mb-5" data-aos="fade-up" data-aos-once="true">
                My Best Services
            </h2>
            <div class="row">
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/logo" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img" :src="require('@/assets/images/services/blogo.png')">
                            <p>Business Logo</p>
                        </div>

                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/appui" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img"
                                :src="require('@/assets/images/services/mobile_app.png')">
                            <p>Mobile App UI/UX</p>
                        </div>
                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/website" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img"
                                :src="require('@/assets/images/services/website_ui.png')">
                            <p>Website UI/UX</p>
                        </div>
                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/dashboard" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img"
                                :src="require('@/assets/images/services/dashboard.png')">
                            <p>Dashboard</p>
                        </div>
                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/wireframing" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img"
                                :src="require('@/assets/images/services/wireframing.png')">
                            <p>Wireframing</p>
                        </div>
                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img" :src="require('@/assets/images/services/banners.png')">
                            <p>Banners & Posts</p>
                        </div>
                    </router-link>
                </div>
                <div class="col-sm-3 p-1 tag-slider-wrapper mb-3">
                    <router-link to="/portfolio/screenshot" class="text-decoration-none text-center m-1">
                        <div class="pro-list-section py-5">
                            <img class="tag-slider-wrapper--img"
                                :src="require('@/assets/images/services/app_screenshot.png')">
                            <p>App Screenshot</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>


</template>
  
<script>
export default {
    name: "MyPortfolio",
};
</script>